// UpgradeBadge — gemensam "Uppgradera till X"-knapp/badge att använda
// där vi idag har ad-hoc-implementationer (HistoryUpgradeBanner,
// AtlasUpsellCard, EntityDetailsDialog upgrade-CTA m.fl.). #37
//
// Två varianter:
//   - <UpgradeBadge tier="pro" />            → liten chip, navigerar till /pricing
//   - <UpgradeBadge tier="pro" inline />     → render:as inline i löpande text

import { Zap } from 'lucide-react';
import { Link } from 'react-router-dom';
import { tierDisplayName, type PlanTier } from '@/lib/planTiers';

interface UpgradeBadgeProps {
  /** Tier som krävs för att låsa upp featuren. */
  tier: PlanTier;
  /** Anpassad label (default: "Uppgradera till <Tier>") */
  label?: string;
  /** Visa som inline-text istället för chip. */
  inline?: boolean;
  /** Override default-länkmål (default: /pricing). */
  href?: string;
}

export function UpgradeBadge({ tier, label, inline = false, href = '/pricing' }: UpgradeBadgeProps) {
  const text = label ?? `Uppgradera till ${tierDisplayName(tier)}`;

  if (inline) {
    return (
      <Link
        to={href}
        className="inline-flex items-center gap-1 text-primary hover:underline"
        data-testid="upgrade-badge-inline"
      >
        <Zap className="w-3 h-3" aria-hidden="true" />
        {text}
      </Link>
    );
  }

  return (
    <Link
      to={href}
      className="inline-flex items-center gap-1.5 rounded-full bg-primary/10 text-primary hover:bg-primary/20 px-2.5 py-0.5 text-xs font-medium transition-colors"
      data-testid="upgrade-badge"
    >
      <Zap className="w-3 h-3" aria-hidden="true" />
      {text}
    </Link>
  );
}
